<template>
   <div class="lottie-animation">
      <lottie :options="defaultOptions" :height="20" />
   </div>
</template>

<script>
import Lottie from 'vue-lottie';

import loaderGrey from '@/core/assets/animations/loader-grey.json';
import loaderWhite from '@/core/assets/animations/loader-white.json';
import { Component, Vue } from 'vue-property-decorator';

@Component({
   components: {
      lottie: Lottie,
   },
   data() {
      return {};
   },

   props: {
      color: {
         type: String,
         required: false,
         default: 'White',
      },
   },

   computed: {
      defaultOptions() {
         return { animationData: this.color === 'Grey' ? loaderGrey : loaderWhite };
      },
   },
})
export default class LoadingAnimation extends Vue { }
</script>

<style lang="scss">
.lottie-animation {
   width: 50px;
   max-height: 40px;
   margin: 0 auto;
   text-align: center;
}
</style>
